import React, { Component, Fragment, useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import "./SildeBubble.css";
import "../bootstrap.min.css";

export default function SildeBubble({
    onOpened, hintClosed, currentNudge, fadeIn, botSettings, position, mobile, disabledChatbot
}) {
    const [iseffect,setIsEffect]=useState(true);
    const [hover, setHover] = useState(false);
    const [nudgeavtar, setNudgeAvtar] = useState(false);
    /**
  * Posts a message to the parent window, if this window has one
  * @param {*} msg
  */
    const postMessage = (msg) => {
        if (window.parent) {
            window.parent.postMessage(msg, "*");
        }
    }
    useEffect(() => {
        if(iseffect)
        {
            window.addEventListener(
                "message",
                windowBuddbleMessage,
                false
            );
            if (
                botSettings.bubbleSettings !== undefined &&
                botSettings.bubbleSettings !== null
            ) {
                //Post Message to set the Alignment of bubble iframe
                if (
                    botSettings.bubbleSettings.bubblePosition !== undefined &&
                    botSettings.bubbleSettings.bubblePosition !== null
                ) {
                    const bubblePosition =
                        botSettings.bubbleSettings.bubblePosition;
                    postMessage(
                        `chatbotalign:${bubblePosition.align}|side:${bubblePosition.side}|bottom:${bubblePosition.bottom}|top:350`
                    );
                }
                //Post Message to set the animation settings iframe
                if (
                    botSettings.bubbleSettings.scrollAnimation !== undefined &&
                    botSettings.bubbleSettings.scrollAnimation !== null
                ) {
                    const scrollAnimation =
                        botSettings.bubbleSettings.scrollAnimation;
                    if (scrollAnimation.enabled === true) {
                        postMessage(
                            `chatbotscrollanimation|${scrollAnimation.beforeAnimationTop}|${scrollAnimation.afterAnimationTop}`
                        );
                    }
                }
            } else {
                postMessage(`chatbotremoveposition`);
            }
            setIsEffect(false);
        }
       
    }, [botSettings])

    const windowBuddbleMessage = (event) => {
        if (
            typeof event.data === "string" &&
            event.data.startsWith("nudgepopup:")
        ) {
            setNudgeAvtar(true);
        }
    }
    const nudgeavtar_clicked = () => {
        setNudgeAvtar(false);
        postMessage(`nudgeminimized`);
    }
    const bubble_clicked = () => {
        onOpened();
    }

    const nudge_clicked = () => {
        onOpened();
    }

    const hint_close = (e) => {
        e.stopPropagation();
        hintClosed();
    }

    const handleMouseEnter = () => {
        setHover(true);
    };
    const handleMouseLeave = () => {
        setHover(false);
    };
    return !disabledChatbot ? 
    !nudgeavtar ?(
            <Fragment>
                <div onClick={bubble_clicked}>
                    <div className="silde-bubble">
                        <div dir="auto" className="silde-bubble-textarea" method="textContainer">
                            <span className="bubbletext" method="textContent">
                                <span className="glyphicon glyphicon-comment"></span> Message</span>
                        </div>
                    </div>
                </div>
            </Fragment>
    ):null : null;
}